import { useQueryClient } from "@tanstack/react-query";

import { $api, type components, useIdempotencyKey } from "@/shared/api";

import { paymentQueryOptions } from "./paymentQueryOptions";

type CheckoutIn = components["schemas"]["CheckoutIn"];

// Начать оплату Pro (`POST /api/billing/checkout`). Ключ идемпотентности — один на способ
// оплаты, пока сервер не ответил окончательно: повторное нажатие после обрыва сети вернёт
// тот же платёж. Ответ кладётся в кэш платежа — дальше экран следит за ним.
export const useCreateCheckout = () => {
  const idempotency = useIdempotencyKey();
  const queryClient = useQueryClient();
  const mutation = $api.useMutation("post", "/api/billing/checkout", {
    onSettled: (_data, error) => {
      idempotency.settle(error);
    },
    onSuccess: (payment) => {
      queryClient.setQueryData(paymentQueryOptions(payment.id).queryKey, payment);
    },
  });
  const checkout = (body: CheckoutIn) => {
    mutation.mutate({
      body,
      params: {
        header: { "Idempotency-Key": idempotency.keyFor(`${body.mode}:${body.method}`) },
      },
    });
  };
  return { ...mutation, checkout };
};
